(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pillowcase-options"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => document.querySelectorAll('[data-pillowcase-options]').forEach(picker => {
      if (picker.dataset.ready) return;
      const form = picker.closest('form');
      const select = form.querySelector('[data-variant-select]');
      if (!select) return;
      const variants = JSON.parse(picker.querySelector('[data-pillow-variants]').textContent);
      const fields = [...picker.querySelectorAll('[data-option-index]')];
      const sync = () => {
        const variant = variants.find(v => String(v.id) === select.value);
        if (!variant) return;
        fields.forEach((field, index) => {
          field.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[index]; });
          field.querySelector('[data-selected-label]').textContent = variant.options[index];
        });
        const image = variant.featured_image;
        if (image?.src) form.querySelectorAll('.offer-images img').forEach(img => { img.removeAttribute('srcset'); img.src = image.src; });
      };
      picker.addEventListener('change', event => {
        const values = fields.map(field => field.querySelector('input:checked')?.value);
        const variant = variants.find(v => v.options.every((value, index) => value === values[index]));
        if (!variant || !variant.available) { sync(); return; }
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      });
      select.addEventListener('change', sync);
      select.closest('label').hidden = true;
      picker.hidden = false; picker.dataset.ready = 'true'; sync();
    });
    initialize(); document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

})();
